import { render } from "./SignUpForm.vue?vue&type=template&id=6465dd78&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"

import "./SignUpForm.vue?vue&type=style&index=0&id=6465dd78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6465dd78"],['__file',"src/components/LoginFlow/SignUpForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6465dd78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6465dd78', __exports__)) {
    api.reload('6465dd78', __exports__)
  }
  
  module.hot.accept("./SignUpForm.vue?vue&type=template&id=6465dd78&scoped=true", () => {
    api.rerender('6465dd78', render)
  })

}


export default __exports__